import { render, staticRenderFns } from "./admin_submit_proposal.vue?vue&type=template&id=4eb4fad4&"
import script from "./admin_submit_proposal.vue?vue&type=script&lang=js&"
export * from "./admin_submit_proposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports